const InfrastructureController = () => import('./Controller')

export default function installComponents(Vue) {
  Vue.component('InfrastructureController', InfrastructureController)
}
